import { useContext } from 'react';

import { XYChartColorPaletteContext } from '../context/XYChartColorPalette.context.js';

export const useColorPalette = () => {
  const context = useContext(XYChartColorPaletteContext);

  if (context === undefined) {
    throw new Error(
      'useColorPalette must be used within a XYChartColorPaletteContext',
    );
  }

  return context;
};
